/**
 * Google Map custom with Maps API
 */
export default function googleMap() {
    const mapEl = document.querySelector('#site-map');
    if (!mapEl) return;

    // Styles
    const mapStyles = [
        {
            featureType: 'administrative.country',
            elementType: 'geometry.fill',
            stylers: [
                {
                    saturation: '-35',
                },
            ],
        },
    ];

    // Setup
    const lat = parseFloat(mapEl.dataset.lat);
    const lng = parseFloat(mapEl.dataset.lng);
    const pos = { lat, lng };

    // Map
    const map = new google.maps.Map(mapEl, {
        zoom: parseInt(mapEl.dataset.zoom),
        center: pos,
        styles: mapStyles,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        disableDefaultUI: true,
    });

    // Marker
    const marker = new google.maps.Marker({
        position: pos,
        map: map,
        title: 'Fasola&Partners',
    });

    // Marker click
    marker.addListener('click', function () {
        window.open(mapEl.dataset.link, '_blank');
    });
}
